import actionMdl from "./admin.mdl";

export default actionMdl;
